<template lang="pug">
  v-card(v-if="userCanSeeProjectPlanung")
    v-card-text
      v-tabs(v-model="active")
        template(v-for="month, monthI in times")
          v-tab {{month.name}}
          v-tab-item(style="position: relative")
            div(v-if="active === monthI" style="position: absolute; top: 4px; left: 0; right: 0; bottom: 0;")
              template(v-for="day in month.days")
                div(:style="`height: 100%; display: inline-block; text-align: center; border: 1px solid rgba(0,0,0,0.6); ${day > 1  ? 'border-left-width: 0;' : ''} width: ${month.dayWidth}%`") {{day}}
            .pb-4.pt-1
            template(v-for="time in month.times")
              v-sheet.pa-1.mb-1(@click="show = time" :width="`${time.width}%`" :style="`color: white; background-color: ${time.farbe}; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; margin-left: ${time.skip}%`")
                | {{time.titel}}

    v-dialog(:value="!!show" @input="show = null" width="500")
      v-card(v-if="show")
        div.pa-3(:style="`color: white; background-color: ${show.farbe}`")
          | {{show.titel}}
          br
          | {{show.abteilung}}
        v-card-text
          | {{show.von}} - {{show.bis}}
          template(v-if="show.nachgemeldet")
            br
            | Nachgemeldet
          template(v-if="show.person")
            br
            | Bearbeiter_in: {{show.person.vorname}} {{show.person.nachname}}
          v-divider.my-2
          div(style="white-space: pre-line") {{show.text}}

</template>

<script>
import gql from 'graphql-tag'
import { menus, user } from '../../router'
import moment from 'moment'
moment.locale('de')

export default {
  props: {
    extra: Object
  },
  data() {
    return {
      show: null,
      active: null,
      projektPlanungs: []
    }
  },
  apollo: {
    projektPlanungs: {
      query: gql`query ExtraProjektPlanung($art: String) {
        projektPlanungs(order: "von" where: { bisGte: "now", art: $art }) {
          id
          art
          titel
          text
          abteilung
          farbe
          von
          bis
          nachgemeldet
          person {
            id
            vorname
            nachname
          }
        }
      }`,
      variables() {
        return {
          art: this.extra.options.xid || null
        }
      },
      skip() {
        return !this.userCanSeeProjectPlanung
      }
    }
  },
  computed: {
    userCanSeeProjectPlanung() {
      const person = user && user.person || {}
      const roles = user && user.roles || []
      const art = this.extra.options.xid
      if (person.vorstand || person.abteilungsleitung || person.bereichsleitung || person.projektleitung || person.ticketBearbeiter) {
        return true
      } else if (roles.some((r) => r == `pplan-read_${art}`)) {
        return true
      } else {
        return false
      }
    },
    times() {
      const months = []
      this.projektPlanungs.forEach(planung => {
        const planungMonths = this.planungToMonths(planung).forEach(month => {
          const old = months.find(m => m.name == month.name)
          if (old) {
            old.times.push(month.times[0])
          } else {
            months.push(month)
          }
        })
      })
      const now = moment()
      return months.filter(m => now.isSameOrBefore(m.date, 'month'))
    },
  },
  methods: {
    planungToMonths(planung) {
      const von = moment(planung.von)
      const bis = moment(planung.bis)
      if (von.isAfter(bis)) {
        return []
      }
      let vonFormat = "D"
      if (von.isBefore(bis, 'month')) {
        vonFormat += ". MMMM"
      }
      if (von.isBefore(bis, 'year')) {
        vonFormat += " Y"
      }
      const vonStr = von.format(vonFormat)
      const bisStr = bis.format("D. MMMM Y")
      var months = []
      while (von.isBefore(bis, 'month')) {
        months.push({ von: moment(von), bis: moment(von).endOf('month') })
        von.add(1, 'month')
        von.startOf('month')
      }
      months.push({ von, bis })

      const thisYear = ' ' +  moment().format('Y')
      return months.map(month => {
        const first = month.von.date()
        const last = month.bis.date()
        const days = month.von.daysInMonth()
        return { name: month.von.format('MMMM Y').replace(thisYear, ''), date: moment(month.von), dayWidth: 100/days, days, times: [{ ...planung, skip: 100/days*(first-1), width: 100/days*(last-first+1), von: vonStr, bis: bisStr }] }
      })
    }
  }
}
</script>
